<template>
    <div xclass="fixed xxinset-0 overflow-hidden bg-indigo-500 z-auto">
        <div xclass="absolute xinset-0 overflow-hidden bg-red-500 z-auto">
            <section
                class="
                    absolute
                    inset-y-0
                    pl-16
                    max-w-full
                    right-0
                    flex
                    h-screen
                "
            >
                <div class="w-screen max-w-md z-50" v-if="show">
                    <div
                        class="
                            h-full
                            divide-y divide-gray-200
                            flex flex-col
                            bg-gray-50
                            shadow-xl
                        "
                    >
                        <div class="flex-1 h-0 overflow-y-auto">
                            <header
                                class="
                                    space-y-1
                                    py-6
                                    px-4
                                    bg-blue-900
                                    sm:px-6
                                    tts-button
                                "
                            >
                                <div
                                    class="
                                        flex
                                        items-center
                                        justify-between
                                        space-x-3
                                    "
                                >
                                    <h2
                                        class="
                                            text-lg
                                            leading-7
                                            font-medium
                                            text-blue-50
                                            tts-button-text
                                        "
                                    >
                                        {{ t("tts.polls.new-poll") }}
                                    </h2>
                                    <div class="h-7 flex items-center">
                                        <button
                                            @click="hideModal()"
                                            aria-label="Close panel"
                                            class="
                                                text-blue-200
                                                hover:text-white
                                                transition
                                                ease-in-out
                                                duration-150
                                            "
                                        >
                                            <svg
                                                class="h-6 w-6"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="2"
                                                    d="M6 18L18 6M6 6l12 12"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <p
                                        class="
                                            text-sm
                                            leading-5
                                            text-blue-50
                                            tts-button-text
                                        "
                                    >
                                        {{ t("tts.polls.new-poll-info") }}
                                    </p>
                                </div>
                            </header>
                            <div class="flex-1 flex flex-col justify-between">
                                <div
                                    class="
                                        px-4
                                        divide-y divide-gray-200
                                        sm:px-6
                                    "
                                >
                                    <div class="space-y-6 pt-6 pb-5">
                                        <div class="space-y-1">
                                            <label
                                                for="project_name"
                                                class="
                                                    block
                                                    text-sm
                                                    font-medium
                                                    text-gray-900
                                                "
                                            >
                                                {{ t("tts.polls.question") }}
                                            </label>
                                            <div class="mt-1">
                                                <input
                                                    type="text"
                                                    id="question_input"
                                                    v-model="poll_question"
                                                    maxlength="220"
                                                    class="
                                                        block
                                                        w-full
                                                        shadow-sm
                                                        sm:text-sm
                                                        focus:ring-blue-500
                                                        focus:border-blue-500
                                                        border-gray-300
                                                        rounded-md
                                                    "
                                                />
                                            </div>
                                        </div>

                                        <div class="space-y-1">
                                            <label
                                                for="description"
                                                class="
                                                    block
                                                    text-sm
                                                    font-medium
                                                    leading-5
                                                    text-gray-900
                                                "
                                                >{{
                                                    t("tts.polls.options")
                                                }}</label
                                            >
                                            <div
                                                class="
                                                    relative
                                                    rounded-md
                                                    shadow-sm
                                                "
                                            >
                                                <textarea
                                                    id="description"
                                                    v-model="poll_answers"
                                                    rows="4"
                                                    class="
                                                        block
                                                        w-full
                                                        shadow-sm
                                                        sm:text-sm
                                                        focus:ring-blue-500
                                                        focus:border-blue-500
                                                        border-gray-300
                                                        rounded-md
                                                    "
                                                    maxlength="600"
                                                ></textarea>
                                            </div>
                                            <p
                                                id="privacy_public_description"
                                                class="
                                                    text-gray-500 text-sm
                                                    leading-5
                                                "
                                            >
                                                {{ t("tts.polls.new-row") }}
                                            </p>
                                        </div>

                                        <fieldset class="hidden alv-347">
                                            <legend
                                                class="
                                                    text-sm
                                                    font-medium
                                                    text-gray-900
                                                    hidden
                                                "
                                            >
                                                Privacy
                                            </legend>
                                            <div class="mt-0 x-space-y-5">
                                                <div
                                                    class="
                                                        relative
                                                        flex
                                                        items-start
                                                    "
                                                >
                                                    <div
                                                        class="
                                                            absolute
                                                            flex
                                                            items-center
                                                            h-5
                                                        "
                                                    >
                                                        <input
                                                            id="privacy_public"
                                                            name="privacy"
                                                            aria-describedby="privacy_public_description"
                                                            type="checkbox"
                                                            class="
                                                                focus:ring-indigo-500
                                                                h-4
                                                                w-4
                                                                text-indigo-600
                                                                border-gray-300
                                                            "
                                                            checked
                                                        />
                                                    </div>
                                                    <div class="pl-7 text-sm">
                                                        <label
                                                            for="privacy_public"
                                                            class="
                                                                font-medium
                                                                text-gray-900
                                                            "
                                                        >
                                                            Public access
                                                        </label>
                                                        <p
                                                            id="privacy_public_description"
                                                            class="
                                                                text-gray-500
                                                            "
                                                        >
                                                            Everyone with the
                                                            link will see this
                                                            project.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div
                                        class="space-y-4 pt-4 pb-6"
                                        v-if="activeConcepts.length > 0"
                                    >
                                        <div class="flex text-sm leading-5">
                                            <div
                                                class="
                                                    group
                                                    space-x-2
                                                    inline-flex
                                                    items-center
                                                    text-gray-500
                                                    hover:text-gray-900
                                                    transition
                                                    ease-in-out
                                                    duration-150
                                                "
                                            >
                                                <svg
                                                    class="
                                                        h-5
                                                        w-5
                                                        text-gray-400
                                                        group-hover:text-gray-500
                                                        transition
                                                        ease-in-out
                                                        duration-150
                                                    "
                                                    viewBox="0 0 20 20"
                                                    fill="currentColor"
                                                >
                                                    <path
                                                        fill-rule="evenodd"
                                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                                                        clip-rule="evenodd"
                                                    />
                                                </svg>
                                                <span class="">
                                                    {{
                                                        t(
                                                            "poll-concepts.poll-concept-questions",
                                                            "Concepten"
                                                        )
                                                    }}</span
                                                >
                                            </div>
                                        </div>

                                        <div>
                                            <div class="flow-root mt-6">
                                                <ul
                                                    role="list"
                                                    class="
                                                        -my-5
                                                        divide-y divide-gray-200
                                                    "
                                                >
                                                    <li
                                                        class="py-4"
                                                        v-for="(
                                                            concept, index
                                                        ) in activeConcepts"
                                                        v-bind:key="index"
                                                    >
                                                        <div
                                                            class="
                                                                relative
                                                                focus-within:ring-2
                                                                focus-within:ring-indigo-500
                                                                cursor-pointer
                                                            "
                                                            @click="
                                                                setConceptAsPoll(
                                                                    concept
                                                                )
                                                            "
                                                        >
                                                            <h3
                                                                class="
                                                                    text-sm
                                                                    font-semibold
                                                                    text-gray-800
                                                                "
                                                            >
                                                                <span
                                                                    class="
                                                                        hover:underline
                                                                        focus:outline-none
                                                                    "
                                                                >
                                                                    <!-- Extend touch target to entire panel -->
                                                                    <span
                                                                        class="
                                                                            absolute
                                                                            inset-0
                                                                        "
                                                                        aria-hidden="true"
                                                                    ></span>
                                                                    {{
                                                                        concept.question
                                                                    }}
                                                                </span>
                                                            </h3>
                                                            <div
                                                                class="
                                                                    text-sm
                                                                    text-gray-600
                                                                    line-clamp-2
                                                                "
                                                                v-for="(
                                                                    answer,
                                                                    subindex
                                                                ) in concept.answers"
                                                                v-bind:key="
                                                                    subindex
                                                                "
                                                            >
                                                                <span
                                                                    class="
                                                                        text-sm
                                                                    "
                                                                >
                                                                    &bull;
                                                                    {{ answer }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="
                                flex-shrink-0
                                px-4
                                py-4
                                space-x-4
                                flex
                                justify-end
                            "
                        >
                            <span class="inline-flex rounded-md shadow-sm">
                                <button
                                    @click="hideModal()"
                                    type="button"
                                    class="
                                        py-2
                                        px-4
                                        border border-gray-300
                                        rounded-md
                                        text-sm
                                        leading-5
                                        font-medium
                                        text-gray-700
                                        hover:text-gray-500
                                        focus:outline-none
                                        focus:border-blue-300
                                        focus:shadow-outline-blue
                                        active:bg-gray-50 active:text-gray-800
                                        transition
                                        duration-150
                                        ease-in-out
                                    "
                                >
                                    {{ t("tts.close") }}
                                </button>
                            </span>
                            <span class="inline-flex rounded-md shadow-sm">
                                <button
                                    type="submit"
                                    @click="newPoll()"
                                    class="
                                        inline-flex
                                        justify-center
                                        py-2
                                        px-4
                                        border border-transparent
                                        text-sm
                                        leading-5
                                        font-medium
                                        rounded-md
                                        text-white
                                        bg-blue-600
                                        hover:bg-blue-500
                                        focus:outline-none
                                        focus:border-blue-700
                                        focus:shadow-outline-blue
                                        active:bg-blue-700
                                        transition
                                        duration-150
                                        ease-in-out
                                        tts-button
                                    "
                                >
                                    {{ t("tts.polls.submit-new-poll") }}
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
    mounted() {
        console.log("Polls Create mounted.");

        let self = this;
        setTimeout(function () {
            self.show = true;
            self.getConceptPolls();
        }, 3);
        this.workshop_slug = this.workshop;
    },
    created() {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            document.getElementById("question_input").focus();
        }, 300);
    },
    props: ["talk_id", "room", "workshop"],
    data() {
        return {
            poll_answers: "",
            poll_question: null,
            workshop_slug: null,
            show: false,
            concepts: [],
        };
    },
    methods: {
        hideModal() {
            let self = this;
            this.show = false;
            setTimeout(function () {
                self.$emit("hide");
            }, 600);
        },
        setConceptAsPoll(poll) {
            var self = this;
            axios
                .get("/api/poll-concepts/" + self.room + "?id=" + poll.id)
                .then((response) => {
                    console.info(response.data.answers.join("\n"));

                    this.poll_question = response.data.question;
                    this.poll_answers = response.data.answers.join("\n");
                    poll.hide = true;
                })
                .catch((error) => {
                    // alert(error.response.status);
                });

            // document.getElementById("question_input").focus();
        },
        getConceptPolls() {
            var self = this;
            axios
                .get("/api/poll-concepts/" + self.room + "?except=polls")
                .then((response) => {
                    console.info(response.data.data);
                    this.concepts = response.data.data;
                })
                .catch((error) => {
                    // alert(error.response.status);
                });
        },
        newPoll() {
            let self = this;
            if (self.poll_answers.split("\n").length < 2) {
                return Swal.fire(
                    self.t("tts.polls.submit-wrong"),
                    self.t("tts.polls.wrong-two-options"),
                    "error"
                );
            }
            if (self.poll_question.length <= 1) {
                return Swal.fire(
                    self.t("tts.polls.submit-wrong"),
                    self.t("tts.polls.wrong-empty"),

                    "error"
                );
            }
            Swal.fire({
                title: self.t("tts.polls.submit-new-poll"),
                text: self.t("tts.polls.wrong-empty"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("/api/polls", {
                            answers: self.poll_answers,
                            question: self.poll_question,
                            talk_id: self.talk_id,
                            workshop: self.workshop_slug,
                            room: self.room,
                        })
                        .then((response) => {
                            self.poll_answers = null;
                            self.poll_question = null;
                            Eventing.fire("reloadPolls");
                            self.hideModal();
                        })
                        .catch((error) => {
                            if (error.response) {
                                alert("Error: " + error.response.status);
                            }
                        });
                }
            });
        },
    },
    computed: {
        activeConcepts() {
            var self = this;
            try {
                if (this.concepts) {
                    return this.concepts.filter(function (u) {
                        return !u.hide;
                    });
                }
            } catch (error) {}
            return this.concepts;
        },
    },
};
</script>
